let userTrackerStatus = false;

/**
 *
 * @type {{eventNameValidityCheck: (function(*): boolean), trackAction: ((function(*): (string|undefined))|*), track: (function(*): string)}}
 */
export const UserTracker = {
    // userInfo: "디폴트",
    // funcName: "디폴트",
    trackAction: function (json) {
        if (!userTrackerStatus) return;
        if (!this.eventNameValidityCheck(json?.event)) return;
        collect(json);
        return 'success'
    },
    eventNameValidityCheck: function (event) {
        // [이벤트 명 컨벤션] : 위치:이벤트명:동작 (ex, main:chatting-list:click)
        const result = /^[\w\-]+?:[\w\-]+?:[\w\-]+$/.test(event);
        if (!result) console.error("[dev] 유저 트래커 이벤트명이 컨벤션에 부합하지 않습니다.");
        return result;
    }
}

/**
 * 다양한 조건에 따라 모니터링 사용을 제한합니다.
 * @returns {boolean|(function(*): *)|*|noopFunc|boolean}
 */
function isLimitMonitor() {
    // ENTER, 내부망은 사용을 제한.
    if (window.ServerChecker && window.Often) {
        if (ServerChecker.isEnter || ServerChecker.isInnerNetwork) {
            return true;
        }
    }
    // USER_TRACKER 기능키를 사용하지 않으면 사용 제한.
    return !(window.isUserTracker ?? (Mutil.isFunc("USER_TRACKER") && !Mutil.isFunc("BLOCK_USER_TRACKER")));
}

/**
 * 유저 트래커를 세팅합니다.
 */
export function loadUserTracker() {
    if (isLimitMonitor()) return;

    // 구글 키: 측정 아이디
    const googleKey = {
        // GA: {prod: "G-MX97V2VT8H", dev: "G-5N0B4ZVFMY"},
        GA: {prod: "G-Y2LT9ZCH4Y", dev: "G-MX97V2VT8H"},
        // GTM: {prod: "GTM-PJMHRLW", dev: "GTM-5RWLN3J"},
        GTM: "GTM-5RWLN3J",
    }
    const gaKey = Mutil.isServerOn("REAL") ? googleKey.GA.prod : googleKey.GA.dev;
    // const gtmKey = Mutil.isServerOn("REAL") ? googleKey.GTM.prod : googleKey.GTM.dev;
    const gtmKey = googleKey.GTM;

    GoogleTagManager.initSetting(gtmKey);
    GoogleAnalytics.load(gaKey);
    GoogleAnalytics.initGoogleAnalytics4(gaKey);
    userTrackerStatus = true; // userTracker를 사용할 수 있습니다.
}

/**
 * 유저 트래커에 트래킹 정보를 쌓습니다. 기본적인 데이터와 함께 주가된 데이터를 쌓습니다.
 * @param _JSON
 */
function collect(_JSON) {
    //개인정보 삭제
    delete _JSON.USER_ID
    delete _JSON.USER_NM
    delete _JSON.USE_INTT_ID

    _JSON.userId = btoa(unescape(encodeURIComponent(_JSON.userId)));
    _JSON.date = Time.currentTime()
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
        // 이벤트 데이터
        event: _JSON.event, // 이벤트 명을 넣는다. (위치:이벤트명:동작) => ex, main:chatting-list:click
        value: _JSON.value,
        data: JSON.stringify(_JSON.data),
        ...statisticalIndicatorAttribute(),
        ...userProperties()
    });
}

/**
 * 주로 통계를 낼 수 있는 데이터를 위주로 담습니다.
 * @returns {{IS_GUEST: *, CORP_TYPE: string, CORP_EXPERIENCE: boolean, IS_MINI_MODE: boolean, PLAN_ID: (string|string), IS_ELECTRON: boolean, IS_MANAGER: (*|boolean)}}
 */
function statisticalIndicatorAttribute() {
    const isDataInvalidationPage = /(?:signin|signup)/.test(location.pathname);
    if (isDataInvalidationPage) {
        return {
            PLAN_ID: null,
            CORP_TYPE: null,
            CORP_EXPERIENCE: null,
            IS_MANAGER: null,
            IS_ELECTRON: null,
            IS_GUEST: null,
            IS_MINI_MODE: LocalUtil.getElectronYn() === "Y" && (!ElectronApi.Comm.getConfig({'key': 'b_fullMode'})),
        }
    }

    return {
        PLAN_ID: PlanFunc.getPlanInfo()?.PLAN_ID ?? "",
        CORP_TYPE: _USE_INTT_ID.split("_")[0],
        CORP_EXPERIENCE: LocalUtil.getLocalValue("ONLY_BUY_SETTING", "CARD_BANNER_YN") === "Y",
        IS_MANAGER: LocalUtil.getLocalValue("ONLY_COMPANY_JSON", "isManager") ?? false,
        IS_ELECTRON: LocalUtil.getElectronYn() === "Y",
        IS_GUEST: Mutil.isGuest(),
        IS_MINI_MODE: LocalUtil.getElectronYn() === "Y" && (!ElectronApi.Comm.getConfig({'key': 'b_fullMode'})),
        TRANSLATION_LANGUAGE: window.globalValue?.translationInfo?.TARGET_LANGUAGE ?? "설정값 없음",
        ENV: Mutil.getServerMode()
        // FIRST_LOGIN: isFirstLogin, // 다른 화면에서는 첫 로그인 여부를 알 수 없음.
    }
}

/**
 * 통계를 낼 수 없는 유저가 가지고 있는 속성을 주로 담습니다.
 * @returns {{USER_NM: (string|*), USE_INTT_ID: (string|*), USER_ID: (string|*), USE_INTT_NM: (string|*)}}
 */
function userProperties() {
    return {
        USER_ID: _USER_ID,
        USER_NM: _USER_NM,
        USE_INTT_ID: _USE_INTT_ID,
        USE_INTT_NM: _USE_INTT_NM,
        IS_TEST: /@(?:yopmail\.com|flow\.team)$/i.test(_USER_ID),
    }
}

// TODO: 사용 경로 데이터


/*
// 이전 버전
function collect(_JSON) {
    //개인정보 삭제
    delete _JSON.USER_ID
    delete _JSON.USER_NM
    delete _JSON.USE_INTT_ID

    _JSON.userId = btoa(unescape(encodeURIComponent(_JSON.userId)));
    _JSON.date = Time.currentTime()
    window.dataLayer = window.dataLayer || [];
    gtag('date', new Date());
    gtag('config', 'G-MX97V2VT8H');
    gtag('Event', _JSON.event);
    gtag(_JSON);

    function gtag(){dataLayer.push(arguments);}
}
*/
